import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Divider, Text } from 'src/@vymo/ui/atoms';
import { TabLayout } from 'src/@vymo/ui/blocks';
import { ReactComponent as RightArrow } from 'src/assets/icons/right.svg';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getFilterData, getHelloCardPageData } from '../selectors';
import { fetchHelloCardsForPage } from '../thunk';
import styles from './index.module.scss';

function HelloCard({
  name,
  module,
  pages = [],
}: {
  name: string;
  module: string;
  pages: any;
}) {
  const dispatch = useAppDispatch();
  const filterData = useAppSelector(getFilterData);
  const pageMap = useAppSelector(getHelloCardPageData);
  const [localMap, setLocalMap] = useState({});

  useEffect(() => {
    const updatedMap = {};
    pages.forEach((p) => {
      updatedMap[p.code] = p.categories;
    });
    setLocalMap(updatedMap);
  }, [pages]);

  const options = pages.map((p) => ({ code: p.code, name: p.name }));
  const hasTabs = options.length > 1;

  const [activeTab, setActiveTab] = useState(options?.[0]?.code);

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);

    const params = {
      page: tabKey,
      start_state: module,
      filters: JSON.stringify(filterData?.filterData || {}),
      from_web2: true,
    };

    dispatch(fetchHelloCardsForPage({ params }));
  };

  useEffect(() => {
    if (pageMap[activeTab]) {
      setLocalMap((prev) => ({
        ...prev,
        [activeTab]: pageMap[activeTab],
      }));
    }
  }, [pageMap, activeTab]);

  const metrics = localMap[activeTab] ?? [];

  if (_.isEmpty(options) || _.isEmpty(metrics)) return null;

  return (
    <div className={styles.helloCardItem}>
      <div className={styles.helloCardItem__header}>
        <Text data-test-id={`${name}_leadcard`} semiBold>
          {name}
        </Text>

        {hasTabs && (
          <TabLayout
            classNames={styles.helloCardItem__tabLayout}
            items={options.map((o) => ({
              key: o.code,
              label: o.name,
              children: null,
            }))}
            defaultKey={activeTab}
            onChange={handleTabChange}
          />
        )}
      </div>

      <div className={styles.helloCardItem__metricWrapper}>
        {metrics.map((m, idx) => (
          <>
            {/* eslint-disable-next-line react/no-array-index-key */}
            <div key={idx} className={styles.helloCardItem__metric}>
              <Text>
                {idx + 1}. {m.name}
              </Text>
              <Text classNames={styles.helloCardItem__metric__value}>
                {m.value}
                <RightArrow />
              </Text>
            </div>
            {idx !== metrics.length - 1 && (
              <Divider classNames={styles.helloCardItem__metric__divider} />
            )}
          </>
        ))}
      </div>
    </div>
  );
}

export default HelloCard;
